import { NgModule } from '@angular/core';
import { JournalEntryDetailsComponent } from './journal-entry-details.component';
import { LegfiBalancePipeModule } from '../../../../../pipes/format/legfi-balance.module';
import { CommonModule } from '@angular/common';
import { LegfiDatePipeModule } from '../../../../../pipes/format/legfi-date.module';

@NgModule({
    declarations: [JournalEntryDetailsComponent],
    imports: [
        CommonModule,
        LegfiBalancePipeModule,
        LegfiDatePipeModule,
    ],
    exports: [JournalEntryDetailsComponent],
})
export class JournalEntryDetailsModule
{
}
